import React from 'react';
import { Input } from '../../../components/tailwind/input';
import { Card, CardContent } from '../../../components/tailwind/card';
import { getAuthOtpButtonText } from '../constants/templateConstants';

export default function AuthenticationTemplateForm({ formData, setFormData, validationErrors }) {
  return (
    <Card className="border-gray-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <CardContent className="p-6 space-y-6">
        <div className="h-px bg-gray-100 dark:bg-slate-800" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Message TTL (seconds) <span className="text-gray-400 font-normal">(Optional)</span>
            </label>
            <Input
              type="number"
              min="60"
              className={`bg-gray-50 dark:bg-slate-950 border-gray-200 dark:border-slate-800 text-gray-900 dark:text-white ${validationErrors && validationErrors.messageSendTtlSeconds ? 'border-red-500 focus-visible:ring-red-500' : ''}`}
              value={formData.messageSendTtlSeconds}
              onChange={(e) => setFormData('messageSendTtlSeconds', parseInt(e.target.value) || '')}
            />
            <p className="text-xs text-gray-500">How long the message is valid (default: 600s)</p>
            {validationErrors && validationErrors.messageSendTtlSeconds && (
              <p className="text-xs text-red-500">{validationErrors.messageSendTtlSeconds}</p>
            )}
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Code Expiration (minutes) <span className="text-gray-400 font-normal">(Optional)</span>
            </label>
            <Input
              type="number"
              min="1"
              className={`bg-gray-50 dark:bg-slate-950 border-gray-200 dark:border-slate-800 text-gray-900 dark:text-white ${validationErrors && validationErrors.codeExpirationMinutes ? 'border-red-500 focus-visible:ring-red-500' : ''}`}
              value={formData.codeExpirationMinutes}
              onChange={(e) => setFormData('codeExpirationMinutes', parseInt(e.target.value) || '')}
            />
            <p className="text-xs text-gray-500">How long before the code expires</p>
            {validationErrors && validationErrors.codeExpirationMinutes && (
              <p className="text-xs text-red-500">{validationErrors.codeExpirationMinutes}</p>
            )}
          </div>
        </div>

        <div className="h-px bg-gray-100 dark:bg-slate-800" />

        <div className="space-y-3">
          <h4 className="text-sm font-medium text-gray-900 dark:text-white">OTP Button Configuration</h4>

          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Button Text (Optional)</label>
            <Input
              placeholder={`e.g., ${getAuthOtpButtonText(formData.language)}`}
              className="bg-gray-50 dark:bg-slate-950 border-gray-200 dark:border-slate-800 text-gray-900 dark:text-white"
              value={formData.otpButtonText}
              onChange={(e) => setFormData('otpButtonText', e.target.value)}
              maxLength="25"
            />
            <p className="text-xs text-gray-500">Custom text for the OTP button</p>
          </div>
        </div>

        <div className="space-y-3">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={formData.addSecurityRecommendation}
              onChange={(e) => setFormData('addSecurityRecommendation', e.target.checked)}
              className="rounded border-gray-300"
            />
            <span className="text-sm text-gray-700 dark:text-gray-300">Add security recommendation message</span>
          </label>
          <p className="text-xs text-gray-500">Adds a footer recommending users not to share the code</p>
        </div>
      </CardContent>
    </Card>
  );
}
